const initialState = {
    anchor: 'left',
    convenio: [],
    open: false,
    id: '',
    nome: '',
    endereco: '',
    caminhoLogo: '',
    cnpj: '',
    id_usuario: 0
};

export function convenio(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_CONVENIO':
            return {
                ...state,
                convenio: action.convenio
            };
        case 'CONVENIO_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                endereco: action.endereco,
                caminhoLogo: action.caminhoLogo,
                cnpj: action.cnpj,
                id_usuario: action.id_usuario
            };
        case "CONVENIO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
